import { addDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../../../../config/firebaseConfig";
import { examSubmitEmail } from "../../../../constant/emailTemplates/examSubmit";
import { sendEmailHandler } from "../../../../utils/helperFunctions/sendEmailHandler";
import authService from "../../../../firebase/authService";

export const submitExam = async ({ results, startTime, participantId }) => {
  const totalQuestions = results.length;
  const timeTaken = Date.now() - startTime;
  const correctAnswers = results?.filter(
    (result) => result?.evaluation === "correct"
  )?.length;
  const attemptedQuestions = results?.filter(
    (result) => result?.evaluation !== "unattempted"
  ).length;
  const score = Math.round((correctAnswers / totalQuestions) * 100);
  //update Result data to firestore db
  const resultData = {
    participantId,
    totalQuestions,
    attemptedQuestions,
    correctAnswers,
    score,
    timeTaken,
    quesionsResults: results,
    startTime: Timestamp.fromDate(new Date(startTime)),
  };

  try {
    const resultRef = await addDoc(collection(db, "results"), resultData);
    return resultRef;
  } catch (error) {
    throw error;
  }
};

export const sendExamSubmitEmail = async ({ participantName }) => {
  const user = await authService.getCurrentUser();
  const { displayName: userName, email: emailId } = user;
  const subject = `Olympiad Result - ${participantName}`;
  const body = examSubmitEmail(userName, participantName);
  try {
    await sendEmailHandler({ emailId, subject, body });
  } catch (error) {
    throw error;
  }
};

export const handleFullScreen = () => {
  if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
    document.documentElement.webkitRequestFullscreen();
  }
};
